import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Api from 'api';
import * as Actions from 'actions';
import * as Permissions from 'permissions';
import {
  Container,
  ToggleSwitch,
  NotificationAdminOptions
} from 'components';
import {
  Button,
  Panel,
  Alert,
  Row,
  Col,
} from 'react-bootstrap';
import { copy } from 'utils';

@connect(() => ({}), Actions)
class NotificationOptions extends Component {
  constructor(props) {
    super(props);

    this.addGroup = this.addGroup.bind(this);
    this.removeGroup = this.removeGroup.bind(this);
    this.updateUserGroup = this.updateUserGroup.bind(this);
    this.state = {
      user_groups: [],
      groups: [],
    }
  }
  componentDidMount() {
    Promise.all([
      Api.getUserNotificationGroups(),
      Api.getNotificationGroups()
    ]).then(([ user_groups, groups ]) => this.setState({ user_groups, groups }))
    .catch(this.props.notify);
  }
  updateUserGroup(group) {
    const hasGroup = this.state.user_groups.find(({ name, category }) => group.name == name && group.category == category) ? true : false;
    let user_groups = [];

    if(hasGroup) {
      user_groups = [
        ...copy(this.state.user_groups.filter(({ name, category }) => !(group.name == name && group.category == category)))
      ]
    }
    else {
      user_groups = [
        group,
        ...copy(this.state.user_groups.filter(({ name, category }) => !(group.name == name && group.category == category)))
      ]
    }

    Api.setUserNotificationGroups(user_groups).then(d => {
      this.setState({ user_groups });
    })
    .catch(this.props.notify);
  }
  removeGroup(group) {
    Api.removeNotificationGroup(group)
      .then(f => {
        const groups = this.state.groups.filter(({ name, category}) => !(group.name == name && group.category == category));
        this.setState({ groups });
      })
      .catch(this.state.notify);
  }
  addGroup(group) {
    const groups = [ copy(group), ...this.state.groups.filter(({ name, category }) => !(group.name == name && group.category == category)).map(copy) ];
    Api.setNotificationGroups(groups).then(f => {
      this.setState({
        groups
      });
    })
    .catch(this.props.notify);
  }
  render() {
    const groups = {};
    this.state.groups.forEach(({ name, category }) => {
      if(!groups[category]) {
        groups[category] = [];
      }
      groups[category].push({ name, category });
    });
    const groupNames = Object.keys(groups);
    const canEditNotifications = this.props.hasPermission(Permissions.EDIT_NOTIFICATIONS);

    return (
      <div className='notification-options-container'>
        <Alert bsStyle='info'>
          <h3>Notification Settings</h3>
          <p>Select which regions you would like to receive notifications for.</p>
        </Alert>
        <Row>
          {groupNames.length > 0 ? <Col xs={12} md={canEditNotifications ? 6 : 12} lg={canEditNotifications ? 9 : 12}>
            <Row>
              {groupNames.map(groupName => (
                <Col xs={12} md={6} key={groupName}>
                  <Panel header={<h3>{groupName}</h3>}>
                    <Row>
                      {groups[groupName].map(({ name, category }) => (
                        <Col xs={12} sm={3} md={4} key={`${name}-${category}`}>
                          <ToggleSwitch onClick={e => this.updateUserGroup({ name, category })} on_condition={this.state.user_groups.find((user_group) => user_group.name == name && user_group.category == category) ? true: false} />
                          <label className='ml-sm control-label'>{' ' + name}</label>
                          {canEditNotifications ? <Button className='pull-right' onClick={e => this.removeGroup({ name, category })}><i className="fa fa-trash" /></Button> : null}
                        </Col>
                      ))}
                    </Row>
                  </Panel>
                </Col>
              ))}
            </Row>
          </Col> : null}
          {canEditNotifications ? (
            <Col xs={12} md={6} lg={3}>
              <NotificationAdminOptions addGroup={this.addGroup} />
            </Col>
          ) : null}
        </Row>
      </div>
    );
  }
}

export default NotificationOptions;



// WEBPACK FOOTER //
// ./src/browser/components/settings/notifications/notification-options.js